/**
 * Shared page header — one <h1>/<p> block per screen, so the title's
 * font-serif/text-2xl/font-bold treatment can never drift between screens
 * (settings' h1 had silently dropped font-bold before this was extracted).
 */
export function PageHeader({
	title,
	description,
}: {
	title: string;
	description: string;
}) {
	return (
		<header>
			<h1 className="font-serif text-2xl font-bold text-foreground">{title}</h1>
			<p className="mt-1 text-sm text-muted-foreground">{description}</p>
		</header>
	);
}
